import PropTypes from "prop-types";
import cn from "classnames";
import { InfoFill } from "@icons/info";

function NoResults({ className = "", error = null }) {
  if (error) {
    return (
      <div className={className}>
        {error?.status} {error?.message} | <em>No results found</em>
      </div>
    );
  }
  return (
    <div
      className={cn(
        "bg-blue-100 p-10 rounded md:flex md:align-middle",
        className
      )}
    >
      <InfoFill className="mt-2 mb-4 m-auto" width="32px" height="32px" />
      <div className="ml-4">
        <p>
          Based on the filters you selected, there are no results available.
          Please try selecting a different combination of filters.
        </p>
      </div>
    </div>
  );
}

NoResults.propTypes = {
  className: PropTypes.string,
  error: PropTypes.shape({
    status: PropTypes.string,
    message: PropTypes.string,
  }),
};

export { NoResults };
